"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderRadiusCircle = exports.borderRadiusLarge = exports.borderRadiusSmall = void 0;

/*
 * @usage
 * const roundAllCorners = css`
 *   ${ borderRadiusSmall }
 * `
 * const roudOnlyLeftCorners = css`
 *   ${ borderRadiusSmall.left }
 * `
 */
var borderRadiusSmall = {
  left: 'border-radius: 3px 0 0 3px;',
  right: 'border-radius: 0 3px 3px 0;',
  all: 'border-radius: 3px;',
  toString: function toString() {
    return borderRadiusSmall.all;
  }
};
exports.borderRadiusSmall = borderRadiusSmall;
var borderRadiusLarge = {
  left: 'border-radius: 6px 0 0 6px;',
  right: 'border-radius: 0 6px 6px 0;',
  all: 'border-radius: 6px;',
  toString: function toString() {
    return borderRadiusLarge.all;
  }
};
exports.borderRadiusLarge = borderRadiusLarge;
var borderRadiusCircle = {
  left: 'border-radius: 50% 0 0 50%;',
  right: 'border-radius: 0 50% 50% 0;',
  all: 'border-radius: 50%;',
  toString: function toString() {
    return borderRadiusCircle.all;
  }
};
exports.borderRadiusCircle = borderRadiusCircle;